module.exports = __webpack_public_path__ + "static/img/value-icon1.c8fd11ee.png";